import React from 'react'
import { Link } from 'react-router'

import Parallax from '../Parallax'
import { ROUTE_MEDIA_ENREGISTREMENTS, ROUTE_MEDIA_PHOTOS, ROUTE_MEDIA_VIDEOS } from '../../constants'

const MediaHome = () => (
  <div>

    <Parallax image="media" alt="Médias" title="Médias"/>

    <div className="row">

      <div className="col s12 m4">
        <Link activeClassName={'active'} to={ROUTE_MEDIA_ENREGISTREMENTS}>
          <div className="center promo promo-example">
            <i className="material-icons">audiotrack</i>
            <p className="promo-caption">Enregistrements</p>
            <p className="light center">Retrouvez la liste de nos morceaux, à écouter via
              Soundcloud.</p>
          </div>
        </Link>
      </div>

      <div className="col s12 m4">
        <Link activeClassName={'active'} to={ROUTE_MEDIA_PHOTOS}>
          <div className="center promo promo-example">
            <i className="material-icons">perm_media</i>
            <p className="promo-caption">Photos</p>
            <p className="light center">Découvrez dans nos albums photos les plus beaux clichés du
              Baudet.</p>
          </div>
        </Link>
      </div>

      <div className="col s12 m4">
        <Link activeClassName={'active'} to={ROUTE_MEDIA_VIDEOS}>
          <div className="center promo promo-example">
            <i className="material-icons">video_library</i>
            <p className="promo-caption">Vidéos</p>
            <p className="light center">Certaines de nos prestations ont été filmées. Ça va swinger.
              Enjoy !</p>
          </div>
        </Link>
      </div>

    </div>

    <Parallax image="friends" alt="Amis"/>

  </div>
);


export default MediaHome



/** WEBPACK FOOTER **
 ** ./src/components/Media/MediaHome.jsx
 **/